// @ts-nocheck

import { AppEnvSetting } from '@/config';
import React from 'react';
import { Helmet } from 'react-helmet';

let interVal: any = null;
interface Props {
  onReady: () => void;
}
var EScottScript = ({ onReady }: Props) => {
  React.useEffect(() => {
    interVal = window.setInterval(() => {
      if (window.SpsvApi) {
        onReady();
        if (interVal) {
          window.clearInterval(interVal);
        }
      }
    }, 1000);
    return () => {
      if (interVal) {
        window.clearInterval(interVal);
      }
      document.getElementById('SPSVviewIframe')?.remove();
    };
  }, []);
  return (
    <Helmet>
      <script id="e-scott-script" callBackFunc="creditCardCallback" className="spsvToken" async src={AppEnvSetting.eScottUrl}></script>
    </Helmet>
  );
};

export default EScottScript;
